/**
 * 编辑弹窗内列表音视频试播（配合 EditMediaPlayerOverlay）。
 */
export default {
	data() {
		return {
			editPlayingUrl: '',
			editPlayingKind: 'video',
		};
	},
	beforeUnmount() {
		this.stopEditMediaPlay();
	},
	methods: {
		playEditMedia(url, kind = 'video') {
			if (!url) {
				this.$message?.warning?.('暂无可播放内容');
				return;
			}
			this.editPlayingKind = kind === 'audio' ? 'audio' : 'video';
			this.editPlayingUrl = url;
		},
		stopEditMediaPlay() {
			this.editPlayingUrl = '';
		},
	},
};
